<template>
  <div class="">
    <div class="editor">
      <div ref="toolbar" class="toolbar">
      </div>
      <div ref="editor" class="text">
      </div>
    </div>
    <el-dialog title="图片编辑"
    :visible.sync="dialog"
    width="30%">
      <el-form-item label-width="80" label="图片大小:">
        <el-radio-group v-model="image.imgsize">
          <el-radio label="30%">30%</el-radio>
          <el-radio label="50%">50%</el-radio>
          <el-radio label="100%">100%</el-radio>
        </el-radio-group>
      </el-form-item>
     <!-- <el-form-item label-width="80" label="图片说明:">
        <el-input v-model="image.imgInputText"></el-input>
      </el-form-item> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false; image.imgContent = ''">取 消</el-button>
        <el-button type="primary" @click="editImgClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import E from 'wangeditor' // 引入wangeditor富文本编辑器
let editor = null
export default {
  name: 'editor',
  data () {
    return {
      dialog: false,
      image: {
        imgsize: '50%',
        imgInputText: '',
        imgContent: ''
      },
      imgElement: ''
    }
  },
  model: {
    prop: 'editorval',
    event: 'change'
  },
  props: {
    editorval: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.seteditor()
  },
  methods: {
    seteditor () {
      const vueThat = this
      editor = new E(this.$refs.toolbar, this.$refs.editor)
      editor.config.height = 500
      editor.config.pasteFilterStyle = true // 黏贴文件
      editor.config.pasteIgnoreImg = false
      editor.config.zIndex = 1
      // 取消自动 focus
      editor.config.focus = false
      // 配置菜单
      editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        // 'italic', // 斜体
        // 'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        // 'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        // 'video' // 插入视频
        // 'code', // 插入代码
        'undo' // 撤销
        // 'redo' // 重复
      ]
      // 颜色
      editor.config.colors = [
        '#ffffff',
        '#000000',
        '#FF0000',
        '#eeece0',
        '#1c487f',
        '#009999',
        '#606266',
        '#8baa4a',
        '#7b5ba1',
        '#46acc8',
        '#f9963b'
      ]
      editor.config.showLinkImg = false // 隐藏插入网络图片
      editor.config.customUploadImg = async function (files, insert) {
        if (files.length > 5) {
          vueThat.$alert('图片上传数量最多不超过5张', '温馨提示', {
            confirmButtonText: '确定'
          })
        } else {
          const imgUpload = new FormData()
          for (let i = 0; i < files.length; i++) {
            if (imgUpload.has('image')) {
              imgUpload.set('image', files[i])
            } else {
              imgUpload.append('image', files[i])
            }
            await vueThat.myApi.upload(imgUpload).then(function (res) {
              if (res.data.code === 200) {
                editor.cmd.do('insertHTML', `<img src="${res.data.data.url}" style="width: 50%"/>`)
                // editor.txt.append('<p style="text-align: center; "><img src="' + res.data.data.url + '" style="max-width: 50%"><br><span></span></p>')
              }
            })
          }
        }
      }
      // 配置 onchange 回调函数
      editor.config.onchange = (html) => {
        const text = editor.txt.text()
        vueThat.$emit('monitor', html, text)
      }
      // 配置触发 onchange 的时间频率，默认为 200ms
      editor.config.onchangeTimeout = 1000
      // editor.txt.eventHooks.imgClickEvents.push(vueThat.imgClick)
      // editor.txt.eventHooks.toolbarClickEvents.push(vueThat.imgClick)
      // 创建富文本编辑器
      editor.create()
      vueThat.$refs.editor.style.minHeight = '500px'
      // 初始化内容
      editor.txt.html(vueThat.editorval)
    },
    imgClick: function (e) {
      this.dialog = true
      this.imgElement = e.elems[0]
    },
    editImgClose: function () {
      // this.image.imgContent = this.image.imgInputText
      // const span = editor.selection.getSelectionContainerElem().elems[0].querySelectorAll('span')[0]
      // span.innerHTML = this.image.imgContent
      this.dialog = false
      this.imgElement.style.maxWidth = this.image.imgsize
      editor.txt.append(' ')
    }
  }
}
</script>

<style scoped="scoped">
  .editor {
    width: 100%;
  }
  .toolbar {
    flex-wrap: wrap;
    border: 1px solid #ccc;
  }
  .w-e-menu{
    z-index:1 !important;
  }
  .text {
    width:100%;
    border: 1px solid #ccc;
    height: 300px;
  }
  .w-e-menu{
    z-index: 2 !important;
  }
  .w-e-text-container{
    z-index: 1 !important;
  }
</style>
